import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import AlertModal from '../../../../../components/alertModal/alertModal';
import DonutChartWithLabel from '../../../../../components/donutChartWithLabel/DonutChartWithLabel';
import EmptyMessage from '../../../../../components/emptyMessage/EmptyMessage';
import EmptyPlaceholder from '../../../../../components/emptyPlaceholder/EmptyPlaceholder';
import UsageSummeryContainer from '../../../../../components/usageSummeryContainer/UsageSummeryContainer';
import { EPackageType } from '../../../../../interfaces/packageType';
import { ISubscriberData } from '../../../../../interfaces/subscriberData';
import { IDashboardSummary } from '../../../../../interfaces/dashboardSummary';
import { getDashboardSummary } from '../../../../../services/dashboard';
import { bytesToGb } from '../../../../../util/bytesToGb';
import { getProfileData } from '../../../../../services/dashboard';
import { IProfileData } from '../../../../../interfaces/profileData';

interface IProps {
  selectedCircuitId?: string;
  selectedPackageType: EPackageType;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const NoneBroadbandUsage = (props: IProps) => {
  const { loading, setLoading, selectedPackageType, selectedCircuitId } = props;
  const [remainQuota, setRemainQuota] = useState<string>("");
  const [subscriberData, setSubscriberData] = useState<IDashboardSummary>();
  const [profileData, setProfileData] = useState<IProfileData>();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (selectedCircuitId) {
      setLoading(true);

      getDashboardSummary(selectedCircuitId)
        .then((data: IDashboardSummary) => {
          setSubscriberData(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }
  }, [selectedCircuitId, setLoading, selectedPackageType]);

  useEffect(() => {
    if (!subscriberData) {
      return;
    }

    const calcRemain: number =  parseFloat(subscriberData.my_Package_Summary.limit.replace(/,/g, '')) - parseFloat(subscriberData.my_Package_Summary.used.replace(/,/g, ''));

    const remainQuota: string | undefined =
      calcRemain.toString();

    setRemainQuota(remainQuota);
  }, [subscriberData]);

  useEffect(() => {
    if (selectedCircuitId) {
      setLoading(true);

      getProfileData(selectedCircuitId)
        .then((data: IProfileData) => {
          setProfileData(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }
  }, [selectedCircuitId, setLoading, selectedPackageType]);

  return (
    <UsageSummeryContainer
      title={
        <>
          <Row>
            <Col className='col-12 col-md'>
              Monthly Usage{' '}
              {profileData &&
                `as at ${moment(new Date()).format('yyyy-MM-DD hh:mm A')}`}
            </Col>
            {profileData && (
              <Col className='col-auto'>
                User Package: {profileData?.subscriber_Package_Display}
              </Col>
            )}
          </Row>
        </>
      }
    >
      <Row>
        <Col className={'text-center mt-5'}>
          {subscriberData && (
            <DonutChartWithLabel
              data={[
                {
                  label: `Used(GB)`,
                  value: parseFloat(subscriberData.my_Package_Summary.used.replace(/,/g, ''))
                },
                {
                  label: `Remain(GB)`,
                  value: parseFloat(subscriberData.my_Package_Summary.limit.replace(/,/g, '')) - parseFloat(subscriberData.my_Package_Summary.used.replace(/,/g, ''))
                },
              ]}
              totalQuotaBytes={parseFloat(subscriberData.my_Package_Summary.limit.replace(/,/g, ''))}
              remainQuotaBytes={parseFloat(remainQuota)}
            />
          )}
          {!props.selectedCircuitId && <EmptyPlaceholder className='mt-5' />}
          <EmptyMessage
            show={!loading && !!props.selectedCircuitId && !subscriberData}
            message='Records could not be found'
          />
        </Col>
      </Row>
      <AlertModal
        show={!!error}
        variant='error'
        buttons={[
          {
            text: 'OK',
            variant: 'success',
            onClick: () => setError(''),
          },
        ]}
      >
        {error}
      </AlertModal>
    </UsageSummeryContainer>
  );
};

export default NoneBroadbandUsage;
